<template>
  <div class="carts">
    <div class="hed" v-if="list.length > 0">
      <div class="checkall">
        <label :class="checkAll ? 'checked' : ''" @click="clickAll"></label>
        <p>全选</p>
      </div>
      <span @click="clearCart()">删除</span>
    </div>
    <div class="nodata"><p>暂无相关信息</p></div>
    <div v-if="list.length > 0" class="condiv">
      <template v-for="(item, index) in list">
        <section :key="item.id">
          <div class="label">
            <label
              v-if="checkList.indexOf(item.id) > -1"
              @click="cancelCheck(item.id)"
              class="checked"
            ></label>
            <label v-else @click="clickCheck(item.id)"></label>
          </div>
          <div class="img">
            <img :src="item.proGoods.firstPhoto" />
          </div>
          <div class="txt">
            <p class="title">{{ item.proGoods.proName }}</p>
            <p class="ms">{{ item.proGoods.specification.label }}</p>
            <div class="total">
              <span class="price">￥{{ item.proGoods.price }}</span>
              <!-- <span class="delete">￥159</span> -->
              <div>
                <input
                  v-if="item.goodsCount > 0"
                  type="button"
                  value="-"
                  class="btn1"
                  @click="sub(index)"
                />
                <input v-else type="button" value="-" class="btn1" style="color:#ccc;" />
                <span class="number">{{ item.goodsCount }}</span>
                <input type="button" value="+" class="btn2" @click="add(index)" />
              </div>
            </div>
          </div>
        </section>
      </template>
    </div>
    <div
      v-else
      class="condiv"
      style="display: flex;
    text-align: center;
    width: 100%;
    align-items: center;
    height: 10rem;
    align-items: center;
    justify-content: center;"
    >
      暂无商品~
    </div>
    <section class="footer" v-if="list.length > 0">
      <p class="price">
        总计： <i>￥{{ sumAmount }}</i>
      </p>
      <p class="price">
        折后： <i>￥{{ sumAmount }}</i>
      </p>
      <a href="javascript:void(0)" @click="submitOrder()">
        <div class="settle">立即结算({{ sumCount }})</div>
      </a>
    </section>
  </div>
</template>

<script>
export default {
  name: 'cart',
  data() {
    return {
      sumCount: 0,
      sumAmount: 0,
      list: [],
      checkAll: false,
      checkList: [],
    }
  },
  created() {
    var params = this.$route.params
    var channel = params['channel']
    this.queryCardGoods(channel)
  },
  methods: {
    updateCartCount(index) {
      this.$submit('/api/mycart/addCart', {
        myId: this.$store.getters.userId,
        goodsId: this.list[index].goodsId, // 具体的ID
        goodsCount: this.list[index].goodsCount, // 具体的数量
      })
    },
    clearCart() {
      // this.$dialog({ message: '提示' })
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认要删除选择的商品吗？',
        })
        .then(() => {
          var that = this
          if (this.checkList.length > 0) {
            var goodsIdArray = []
            for (var i = 0; i < this.list.length; i++) {
              if (this.checkList.indexOf(this.list[i]['id']) > -1) {
                goodsIdArray.push(this.list[i]['goodsId'])
              }
            }
            this.$submit(
              '/api/mycart/removeCart',
              {
                myId: this.$store.getters.userId,
                goodsIds: goodsIdArray,
              },
              function(res) {
                if (res.code == 1) {
                  for (var i = 0; i < that.list.length; i++) {
                    if (that.checkList.indexOf(that.list[i]['id']) > -1) {
                      that.list.splice(i--, 1)
                    }
                  }
                  that.checkListSum()
                  that.checkAll = false
                  that.checkList = []
                }
              }
            )
          }
        })
        .catch(() => {
          // on cancel
        })
    },
    goodsTotal() {
      let _total = 0
      this.list.map(item => {
        if (this.checkList.indexOf(item.id) > -1) {
          _total = _total + item.goodsCount
        }
      })
      this.sumCount = _total
    },
    add(index) {
      this.list[index].goodsCount = this.list[index].goodsCount + 1
      this.checkListSum()
      this.updateCartCount(index)
    },
    sub(index) {
      this.list[index].goodsCount = this.list[index].goodsCount - 1
      this.checkListSum()
      this.updateCartCount(index)
    },
    checkListSum() {
      //this.sumCount = this.checkList.length

      this.sumAmount = 0
      for (var index in this.list) {
        var item = this.list[index]
        if (this.checkList.indexOf(item.id) > -1) {
          this.sumAmount += item.proGoods.price * item.goodsCount
        }
      }
      this.goodsTotal()
    },
    clickAll() {
      this.checkAll = !this.checkAll
      if (this.checkAll) {
        this.checkList = []
        this.list.map(item => {
          this.checkList.push(item.id)
        })
      } else {
        this.checkList = []
      }
      this.checkListSum()
    },
    clickCheck(id) {
      if (this.checkList.indexOf(id) < 0) this.checkList.push(id)
      this.checkListSum()
    },
    cancelCheck(id) {
      let _index = 0
      if (this.checkList.indexOf(id) > -1) {
        _index = this.checkList.indexOf(id)
        this.checkList.splice(_index, 1)
      }
      this.checkListSum()
    },
    queryCardGoods(channel) {
      var that = this
      this.$queryPage(
        'MyCart',
        { myId: this.$store.getters.userId, channel: channel},
        ['id,goodsId,goodsCount,proGoods.price,proGoods.firstPhoto,proGoods.proName,proGoods.specification,proGoods.price'],
        function(res) {
          that.checkAll = true
          that.$fill(that.list, res['data'])
          //that.sumCount = that.list.length
          that.goodsTotal()
          that.checkList = []
          for (var index in that.list) {
            var item = that.list[index]
            that.checkList.push(item.id)
            that.sumAmount += item.proGoods.price * item.goodsCount
          }
        }
      )
    },
    submitOrder() {
      var that = this
      var goodsList = []
      for (var index in this.list) {
        if (
          this.checkList.indexOf(this.list[index]['id']) > -1 &&
          this.list[index]['goodsCount'] > 0
        ) {
          goodsList.push({
            goodsId: this.list[index]['goodsId'],
            count: this.list[index]['goodsCount'],
          })
        }
      }
      if (goodsList.length > 0) {
        this.$submit(
          '/api/order/addOrderWithShop',
          {
            myId: this.$store.getters.userId,
            goodsList: goodsList,
          },
          function(res) {
            if (res['code'] === 1) {
              // alert('成功')
              that.$router.push({ path: '/shop/payok', query: { orderNo: res['data']['orderNo'] } })
            }
          }
        )
      }
    },
  },
  watch: {
    checkList() {
      if (this.checkList.length != this.list.length) {
        this.checkAll = false
      } else {
        this.checkAll = true
      }
    },
  },
}
</script>

<style>
.carts {
  padding: 1rem;
  background: #f3f3f3;
}

.carts .hed {
  width: 100%;
  height: 5rem;
  text-align: center;
  position: relative;
  color: #323232;
  background: #fff;
  border-bottom: 1px solid #eee;
  font-size: 1.4rem;
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 1rem;
}
.carts .hed .checkall {
  display: flex;
  align-items: center;
  height: 2.2rem;
}
.carts .hed .checkall label.checked:before {
  background: url(../../assets/yes.png) no-repeat 50%;
  background-size: contain;
}

.carts .hed .checkall label:before {
  content: '';
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  margin-right: 0.8rem;
  background: url(../../assets/no.png) no-repeat 50%;
  background-size: contain;
}
.carts .nodata {
  display: none;
  width: 12rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.carts .nodata p {
  font-size: 1.4rem;
  color: #999;
  text-align: center;
  height: 2.4rem;
  line-height: 2.4rem;
  margin-top: 1.4rem;
}
.carts .condiv {
  background-color: #fff;
}
.carts .condiv section {
  height: 10rem;
  padding: 1rem;
  box-sizing: border-box;
  font-size: 1.4rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}
.carts .condiv section .label {
  margin: 0 1.4rem 0 0;
}
.carts .condiv section .label label.checked:before {
  background: url(../../assets/yes.png) no-repeat 50%;
  background-size: contain;
}

.carts .condiv section .label label:before {
  content: '';
  display: inline-block;
  width: 1.8rem;
  height: 1.8rem;
  margin-top: 3.3rem;
  background: url(../../assets/no.png) no-repeat 50%;
  background-size: contain;
}

.carts .condiv section .img img {
  width: 8rem;
  height: 8rem;
  margin-right: 1.3rem;
}
.carts .condiv section .txt {
  width: 22rem;
}
.carts .condiv section .txt .title {
  height: 3.7rem;
  line-height: 2rem;
  overflow: hidden;
}
.carts .condiv section .txt .ms {
  font-size: 1.2rem;
  height: 1.7rem;
  color: #999;
}
.carts .condiv section .txt .total {
  display: flex;
  justify-content: space-between;
  line-height: 2.2rem;
}
.carts .condiv section .txt .total .price {
  font-size: 1.6rem;
  color: #15a892;
  padding-top: 0.4rem;
  font-weight: bolder;
}
.carts .condiv section .txt .total .delete {
  text-decoration: line-through;
  font-size: 1.4rem;
  color: grey;
  padding-top: 0.4rem;
}
.carts .condiv section .txt .total .btn1,
.carts .condiv section .txt .total .btn2 {
  width: 2.4rem;
  height: 2.4rem;
  background: transparent;
  border: 1px solid #eee;
  display: inline-block;
  box-sizing: content-box;
  float: left;
}

.carts .condiv section .txt .total .number {
  width: 3.2rem;
  height: 2.4rem;
  text-align: center;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  display: inline-block;
  box-sizing: content-box;
  float: left;
}
.carts .condiv section .txt .total .btn1,
.carts .condiv section .txt .total .btn2 {
  width: 2.4rem;
  height: 2.4rem;
  background: transparent;
  border: 1px solid #eee;
  display: inline-block;
  box-sizing: content-box;
  float: left;
}
input,
input[type='button'],
input[type='reset'],
input[type='search'],
input[type='submit'],
textarea {
  -webkit-appearance: none;
}
.carts .footer {
  background: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 1.4rem;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  display: flex;
  justify-content: flex-end;
}
.carts .footer .price {
  margin: 0 1.7rem 0 0;
}
.carts .footer .price i {
  color: #15a892;
  font-weight: bolder;
}
.carts .footer .price {
  margin: 0 1.7rem 0 0;
}
.carts .footer .price i {
  color: #15a892;
  font-weight: bolder;
}
.carts .footer .settle {
  background: #15a892;
  color: #fff;
  width: 13.5rem;
  text-align: center;
}
</style>
